
define('eteration/widgets/ui-form-items',[
	'knockout',
	'eteration/widgets/widget-util',
	'eteration/eteration-i18n',
	'jquery.alphanum',
	'jquery.mask',
	'eteration/widgets/ui-i18n'
	
	], function(ko,widgetUtil,i18n){
		
	widgetUtil.setupStringBasedTemplate(ko);

	var labelHtml = "<label data-bind=\"i18n-text: { key: label , locale: language}\"></label>";
	
	ko.templates["form-item-numeric"]=		
			labelHtml+
			"<input type=\"text\"  class=\"form-control\" data-bind=\"value : value , attr:{'data-validation':dataValidation , id : id}  ,numeric-input:{maxDigits:maxlength}\"/>";

	ko.bindingHandlers['form-item-numeric'] = {
		init : function(element, valueAccessor, allBindings) {
	        
	       return  ko.bindingHandlers.template.init(element,makeTemplateValueAccessor('form-item-numeric',valueAccessor,allBindings),allBindings);
	    },
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			return ko.bindingHandlers.template.update(element,makeTemplateValueAccessor('form-item-numeric',valueAccessor,allBindings),allBindings, viewModel, bindingContext);
		}
	};

	ko.virtualElements.allowedBindings['form-item-numeric'] = true;

	ko.bindingHandlers["numeric-input"] = {
	    init: function (element, valueAccessor, allBindingsAccessor) {
	    	 var options = ko.utils.unwrapObservable(valueAccessor());
	    	 $(element).numeric(options);
	    	 $(element).on("paste", function(e){
				setTimeout(function(){
					$(element).trigger('change')
				}, 0);
			});
	    }
	};
	
	ko.bindingHandlers["allow-number-with-dot"] = {
		init: function (element, valueAccessor) {
	        $(element).on("keydown", function (event,valueAccessor) {
	            // Allow: backspace, delete, tab, escape, and enter
	            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
	                // Allow: Ctrl+A
	                (event.keyCode == 65 && event.ctrlKey === true) ||
	                // Allow ctrl+v
	                (event.keyCode == 86 && event.ctrlKey === true) ||
	                // Allow: .
	                ( ($("#"+event.srcElement.id).val().indexOf('.') == -1 && event.keyCode == 190) || event.keyCode == 110) ||
	                // Allow: home, end, left, right
	                (event.keyCode >= 35 && event.keyCode <= 39)) {
	                // let it happen, don't do anything
	                return;
	            }
	            else {
	                // Ensure that it is a number and stop the keypress
	                if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode <= 96 || event.keyCode > 105)) {
	                    event.preventDefault();
	                }
	            }
	        });
	    }    
	};

	ko.bindingHandlers["number-only"] = {
		init: function (element, valueAccessor) {
			var $el = $(element);

			function sanitize(str) {
				return str.replace(/\D/g, '');
			}

			$el.on('paste', function (e) {
				setTimeout(function() {
					var cleaned = sanitize(element.value);

					var maxLength = element.maxLength;
					if (maxLength > 0) {
						cleaned = cleaned.substring(0, maxLength);
					}

					if (element.value !== cleaned) {
						element.value = cleaned;

						var observable = valueAccessor();
						if (ko.isObservable(observable)) {
							observable(cleaned);
						}

						$(element).trigger('change');
					}
				}, 0);
			});

			$el.on('input', function () {
				var cleaned = sanitize(this.value);
				if (this.value !== cleaned) {
					this.value = cleaned;

					var observable = valueAccessor();
					if (ko.isObservable(observable)) {
						observable(cleaned);
					}
				}
			});

			$el.on('keydown', function (event) {
				if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 ||
					event.keyCode == 27 || event.keyCode == 13 ||
					(event.keyCode >= 35 && event.keyCode <= 39) ||
					((event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 67 || event.keyCode == 88) && event.ctrlKey === true)) {
					return;
				}

				if (!((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
					event.preventDefault();
				}
			});
		}
	};

    ko.bindingHandlers["tk-number-clean"] = {
        init: function (element, valueAccessor) {
            var $el = $(element);

            function cleanTkPrefix(str) {
                if (!str || typeof str !== 'string') {
                    return str;
                }

                var upperValue = str.toUpperCase();

                if (upperValue.indexOf('TK') === 0) {
                    return str.substring(2);
                }

                return str;
            }

            $el.on('paste', function (e) {
                e.preventDefault();

                var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
                var pastedText = clipboardData.getData('text');

                var tkCleaned = cleanTkPrefix(pastedText);

                var maxLength = element.maxLength;
                if (maxLength > 0 && tkCleaned.length > maxLength) {
                    tkCleaned = tkCleaned.substring(0, maxLength);
                }

                element.value = tkCleaned;

                var observable = valueAccessor();
                if (ko.isObservable(observable)) {
                    observable(tkCleaned);
                }

                $(element).trigger('change');
            });
        }
    };

	ko.bindingHandlers["number-only-input"] = {//0-9
		init: function (element) {
			$(element).on('input', function (event) {
				var text = $(this).val();
				if (isNaN(text)) {
					$(this).val(text.replace(/[^\d]/gi, ''));
					return false;
				}
			});
		}
	};

	ko.bindingHandlers["number-without-zero"] = {//1-9
		init: function (element) {
			$(element).on('keyup', function (event) {
				var text = $(this).val();
				if (text) {
					$(this).val(/[1-9]\d*$/g.exec(text));
					return false;
				}
			});
		}
	};
	
	ko.bindingHandlers["firstdigit-nonzero"] = {
	    init: function (element) {
            $(element).on('keyup', function (event) {
                var text = $(this).val();
                if (text) {
                   $(this).val(text.replace(/^0+/, ''));
                   return false;
                }
            });
	    }    
	};
	
	ko.bindingHandlers.alphaNumericWithDash = {
	    init: function (element, valueAccessor) {
	        var value = valueAccessor();
	        $(element).on("keydown", function (event) {
	            // Allow: backspace, delete, tab, escape, and enter
	            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
	                // Allow: Ctrl+A
	                (event.keyCode == 65 && event.ctrlKey === true) ||		           
	                // Allow: home, end, left, right
	                (event.keyCode >= 35 && event.keyCode <= 39)) {
	                // let it happen, don't do anything
	                return;
	            }
	            else {
	            	if(event.ctrlKey){
	            		 event.preventDefault();
		                    return;
	            	}
	            	
	            		
	            	if(event.keyCode > 57 && event.keyCode < 91){ // char
	            		return;
	            	}
	            	if(event.shiftKey){
	            		 event.preventDefault();
		                    return;
	            	}
	            	if ((event.keyCode > 47 && event.keyCode < 58) || (event.keyCode >= 96 &&  event.keyCode < 106)) {
	                    return;
	                    
	                }
	            	if(event.keyCode == 189){ //dash
	            		return;
	            	}
	            	event.preventDefault();
	            }
	        });
	        
	        if(typeof element == 'undefined') {
        		var element = "";
        	}
	        $(element).change(function () {
	        	if($(element).val() == undefined) {
	        		element = $(e);
	        	}
	        	if(typeof value == 'undefined')
	        		value = $(element).val();
	        });
	    }    
	};
	
	ko.bindingHandlers["number-onlyWODotAndDash"] = {
	    init: function (element) {
	        $(element).on("keydown", function (event) {
	            // Allow: backspace, delete, tab, escape, and enter
	            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||  event.keyCode == 110 ||
	                // Allow: Ctrl+A
	                (event.keyCode == 65 && event.ctrlKey === true) ||
	                // Allow: .
	                // Allow: home, end, left, right
	                (event.keyCode >= 35 && event.keyCode <= 39)) {
	                // let it happen, don't do anything
	                return;
	            }
	            else {
	                // Ensure that it is a number and stop the keypress
	                if (event.shiftKey || event.keyCode == 190 || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 95 || event.keyCode > 105)) {
	                    event.preventDefault();
	                }
	            }
	        });
	    }    
	};
	
	
	ko.bindingHandlers["alphanumeric"] = {//a-zA-Z0-9
	    init: function (element) {

	    	$(element).on('keyup', function (event) {
                var text = $(this).val();
                if (isNaN(text)) {
                   $(this).val(text.replace(/[^a-z0-9]+/gi, ''));
                   return false;
                }
            });
	    }    
	};
	
	
	ko.bindingHandlers["alphanumeric-with-dot"] = {
		init: function (element) {
			$(element).on("keydown", function (event) {
				// Allow: backspace, delete, tab, escape, and enter
				if(event.keyCode == 220 || event.keyCode == 191) {
					event.preventDefault();
				}
				if(event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||  event.keyCode == 110 ||
						// Allow: Ctrl+A
						(event.keyCode == 65 && event.ctrlKey === true) ||
						// Allow: .
						(event.keyCode == 190) ||
						// Allow: home, end, left, right
						(event.keyCode >= 35 && event.keyCode <= 39)) {
					return;
				}
				if (!((event.keyCode > 47 && event.keyCode < 58) && event.shiftKey == false) && // numeric (0-9)
						!(event.keyCode > 64 && event.keyCode < 91) && // upper alpha (A-Z)
						!(event.keyCode >= 96 && event.keyCode < 123)) { // lower alpha (a-z)
					event.preventDefault();
				}
			});
		}    
	};

	ko.bindingHandlers["dynamic-loyaltyMembership-control"] = {
		init: function (element, valueAccessor) {
			$(element).on('keyup', function (event) {
				var text = $(this).val();
				var isNaNText = !isNaN(text);
				if(valueAccessor()) {
					if (!isNaNText) {
						$(this).val(text.replace(/[^\d]/gi, ''));
						return false;
					}
				} else {
					if (!isNaNText) {
						$(this).val(text.replace(/[^a-z0-9]+/gi, ''));
						return false;
					}
				}
			});
		}
	};


	ko.bindingHandlers['char-only'] = {//a-zA-ZşŞıİçÇöÖüÜğĞ
		init: function (element) {
			$(element).on('input', function () {
				var clearedValue = $(this).val().replace(/[^a-zA-ZşŞıİçÇöÖüÜğĞ ]/g, '');
				$(this).val(clearedValue);
			});
		}
	};
   
	
	ko.bindingHandlers["char-wo-special"] = {
	    init: function (element) {
	    	if(!window.isPhoneOrTablet){
		        $(element).on("keydown", function (event) {
		        	if(isAlphabetTr(event.key)) {
			              return true;
			         }else event.preventDefault();	
		        });
	        }
	    	else{
	    		$(element).on('keyup', function(event){
		        	if(isAlphabetTr($(this).val())) {
			           event.preventDefault();
			         }else{
			            $(this).val($(this).val().slice(0,-1));
			         }
		        });
	    	}  
	    }     
	};

	ko.bindingHandlers["char-only-all"] = {
	    init: function (element) {
	    	$(element).on("keydown", function (event) {
	        	if(isAlphabetTr(event.key)) {
	        		 return true;
		         }else event.preventDefault();
	        });

			$(element).on('keyup', function (event) {

				var reg = /^[a-zA-Z ]*$/g;
				var text = $(this).val();
				if (!reg.test(text)) {
					$(this).val(text.replace(/^[a-zA-Z ]*$/gi, ''));

					return false;
				}
			});
	    }
	};
	
	ko.templates["form-item-antext"]=		
			labelHtml+
			"<input type=\"text\"  class=\"form-control\" data-bind=\"value : value , attr:{'data-validation':dataValidation, id : id}  ,alphanum-input:{maxLength:maxlength}\"/>";

	ko.bindingHandlers['form-item-antext'] = {
		init : function(element, valueAccessor, allBindings) {
	        
	       return  ko.bindingHandlers.template.init(element,makeTemplateValueAccessor('form-item-antext',valueAccessor,allBindings),allBindings);
		},
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			return ko.bindingHandlers.template.update(element,makeTemplateValueAccessor('form-item-antext',valueAccessor,allBindings),allBindings, viewModel, bindingContext);
		}
	};

	ko.virtualElements.allowedBindings['form-item-antext'] = true;
	
	
	ko.bindingHandlers["alphanum-input"] = {
	    init: function (element, valueAccessor, allBindingsAccessor) {
	    	 var options = ko.utils.unwrapObservable(valueAccessor());
	    	 $(element).alphanum(options);
	    }
	};
	
	ko.bindingHandlers["alpha-input"] = {
	    init: function (element, valueAccessor, allBindingsAccessor) {
	    	 var options = ko.utils.unwrapObservable(valueAccessor());
	    	 $(element).alpha(options);
	    }
	};
	
	ko.templates["form-item-text"]=		
		labelHtml+
		"<input type=\"text\"  class=\"form-control\" data-bind=\"value : value , attr:{'data-validation':dataValidation , maxlength:maxlength, id : id}  \"/>";

	ko.bindingHandlers['form-item-text'] = {
		init : function(element, valueAccessor, allBindings) {
	        
	       return  ko.bindingHandlers.template.init(element,makeTemplateValueAccessor('form-item-text',valueAccessor,allBindings),allBindings);
		},
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			return ko.bindingHandlers.template.update(element,makeTemplateValueAccessor('form-item-text',valueAccessor,allBindings),allBindings, viewModel, bindingContext);
		}
	};

	ko.virtualElements.allowedBindings['form-item-text'] = true;


	ko.templates["form-item-password"]=		
		labelHtml+
		"<input type=\"password\"  class=\"form-control\" data-bind=\"value : value , attr:{'data-validation':dataValidation , maxlength:maxlength, id : id}  \"/>";

	ko.bindingHandlers['form-item-password'] = {
		init : function(element, valueAccessor, allBindings) {
	        
	       return  ko.bindingHandlers.template.init(element,makeTemplateValueAccessor('form-item-password',valueAccessor,allBindings),allBindings);
		},
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			return ko.bindingHandlers.template.update(element,makeTemplateValueAccessor('form-item-password',valueAccessor,allBindings),allBindings, viewModel, bindingContext);
		}
	};

	ko.virtualElements.allowedBindings['form-item-text'] = true;

		
	ko.templates["form-item-mask"]=		
		labelHtml+
		"<input type=\"text\"  class=\"form-control\" data-bind=\"value : value , attr:{'data-validation':dataValidation, id : id}  ,mask-input:{mask:mask,options:maskOptions}\"/>";

		ko.bindingHandlers['form-item-mask'] = {
		init : function(element, valueAccessor, allBindings) {
		   var tva = makeTemplateValueAccessor('form-item-mask',valueAccessor,allBindings);
	       return  ko.bindingHandlers.template.init(element,tva,allBindings);
		},
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			var tva = makeTemplateValueAccessor('form-item-mask',valueAccessor,allBindings);
			return ko.bindingHandlers.template.update(element,tva,allBindings, viewModel, bindingContext);
		}
	};

	ko.virtualElements.allowedBindings['form-item-mask'] = true;


	ko.bindingHandlers["mask-input"] = {
	    init: function (element, valueAccessor, allBindingsAccessor) {
	    	 var args = ko.utils.unwrapObservable(valueAccessor());
	    	 $(element).mask(args.mask,args.options);
	    }
	};	
	
	ko.bindingHandlers["checkUsername-corporateOrPersonal"] = {
		update : function(element, valueAccessor, allBindingsAccessor) {
			var accessor = valueAccessor();
			var username = ko.utils.unwrapObservable(accessor.username);
			
			if(username){
				var data_validation_for_coporate ='{"required":true,"validator":"minlength","minlength": 4,"minlengthMsg":"Error-OB-90"}'
				var data_validation_for_tknumber ='{"required":true,"validator":"minlength","minlength": 6,"minlengthMsg":"Error-OB-61"}'
				if(isNaN(username)){
					// contains char
					$("#"+element.id).attr("data-validation", data_validation_for_coporate );
				}else{
					$("#"+element.id).attr("data-validation", data_validation_for_tknumber );
				}
				
			}
		}
	}

	ko.bindingHandlers["format-4-digit"] = {
		init: function (element) {
			$(element).on('keyup', function (e) {
			var cardNo =e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
				return $(this).val(cardNo);
			});
		}
	}

	ko.bindingHandlers["text-clean"] = {
		init: function (element, valueAccessor) {
			$(element).on('input', function() {
				var cleaned = this.value.replace(/[^a-zA-ZşŞıİçÇöÖüÜğĞâÂîÎûÛ ]/g, '');

				if (this.value !== cleaned) {
					this.value = cleaned;

					var observable = valueAccessor();
					if (observable && ko.isObservable(observable)) {
						observable(cleaned);
					}
				}
			});
		}
	};


	var isAlphabetTr = function(keyCode){
		if (/^[a-zA-ZşŞıİçÇöÖüÜğĞâÂîÎûÛ ]*$/g.test(keyCode)){
			return true;
		}else return false;
	};	
	var isAlphabet = function(keyCode){
		if (/^[a-zA-Z ]*$/g.test(keyCode)){
			return true;
		}else return false;
	};		
	var makeTemplateValueAccessor =  function(tname,valueAccessor, allBindings) {
		var label = valueAccessor().label || {};
	    var language = valueAccessor().locale || i18n.getUserLocale(); 
	    var value = valueAccessor().value || {};
	    var id = valueAccessor().id || label;
	    var mask = valueAccessor().mask;
	    var maskOptions = valueAccessor().maskOptions || {};

	    var maxlength = valueAccessor().maxlength || NaN;
	  
	    var dataValidation= valueAccessor().validate || '{"required":false}';
	    
		return function() {
			return {
				name : tname,
				
				data : {
					value : value,
					label : label,
					language : language,
					maxlength : maxlength,
					id : id,
					mask : mask,
					maskOptions: maskOptions,
					dataValidation : JSON.stringify(dataValidation)
				}
			};
		};
	};

	var addCleanerEvent = function (element, regexExp) {
		var regex = new RegExp(regexExp, 'gi');
		$(element).on('input', function () {
			var cleanedValue = $(this).val().replace(regex, '');
			$(this).val(cleanedValue);
		});
	}

	ko.bindingHandlers['email-chars'] = {
		init: function (element) {
			addCleanerEvent(element, "[\\!#$%&'*+/=?`{|}~^ıöüçğşİ]");
		}
	}

	ko.bindingHandlers['non-numbers'] = {
		init: function (element) {
			addCleanerEvent(element, "\\d");
		}
	}
});





